export default {
  SPIN: 'GIRAR',
  'You are not eligible for free spins':
    'Apenas as contas steam com o jogo CSGO e sem VAC são elegíveis para moedas gratuitas. Faça login novamente no site para atualizar.',
  'It must be 24 hours since last roll': 'Devem ter passado 24 horas desde a última jogada.',
};
